export const Tile = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 -0.5 16 16"
      shape-rendering="crispEdges"
    >
      <metadata>
        Made with Pixels to Svg https://codepen.io/shshaw/pen/XbxvNj
      </metadata>
      <path
        stroke="#16181e"
        d="M0 0h1M0 5h1M0 7h1M0 8h1M0 9h1M0 10h1M0 11h1M0 12h1M0 13h2M0 14h1M0 15h9M10 15h1"
      />
      <path
        stroke="#222428"
        d="M1 0h1M0 1h1M0 2h1M0 3h1M0 4h2M0 6h2M1 8h2M1 9h1M2 11h1M1 12h1M4 12h1M2 13h2M1 14h2M5 14h1M7 14h1M9 15h1M11 15h2"
      />
      <path
        stroke="#333436"
        d="M2 0h1M1 1h1M2 2h1M1 3h1M2 4h2M5 4h1M4 5h1M7 5h1M2 6h2M5 6h2M2 7h1M3 8h1M6 8h1M2 9h1M4 9h1M1 10h1M3 10h1M5 10h2M9 10h2M1 11h1M3 11h2M2 12h1M5 12h1M6 13h1M3 14h2M6 14h1M8 14h2M13 15h2"
      />
      <path
        stroke="#3d3e40"
        d="M3 0h1M2 1h6M12 1h1M14 1h1M1 2h1M3 2h1M5 2h1M9 2h1M12 2h1M14 2h1M2 3h9M4 4h1M6 4h2M10 4h3M1 5h3M5 5h2M8 5h2M13 5h2M4 6h1M7 6h2M10 6h3M1 7h1M3 7h8M4 8h2M7 8h1M9 8h1M11 8h3M3 9h1M5 9h8M14 9h1M2 10h1M4 10h1M7 10h2M11 10h1M5 11h6M13 11h2M3 12h1M6 12h2M11 12h1M4 13h2M7 13h6M10 14h1M13 14h2M15 15h1"
      />
      <path
        stroke="#4b4c4e"
        d="M4 0h2M8 1h2M11 1h1M13 1h1M4 2h1M6 2h3M10 2h1M11 3h2M8 4h2M13 4h2M10 5h1M12 5h1M9 6h1M13 6h1M11 7h2M8 8h1M10 8h1M14 8h1M13 9h1M12 10h1M14 10h1M11 11h1M8 12h3M12 12h1M13 13h1M15 13h1M11 14h2M15 14h1"
      />
      <path
        stroke="#616266"
        d="M6 0h2M10 1h1M11 2h1M13 2h1M13 3h2M11 5h1M13 7h2M13 10h1M12 11h1M15 11h1M13 12h3M14 13h1"
      />
      <path
        stroke="#727377"
        d="M8 0h8M15 1h1M15 2h1M15 3h1M15 4h1M15 5h1M14 6h2M15 7h1M15 8h1M15 9h1M15 10h1"
      />
    </svg>
  );
};
